import React from 'react';
import { SectionLabel } from './SectionLabel';
import { Bloom } from './Bloom';
export function AdReporting() {
  return <section className="relative isolate overflow-hidden border-b border-[#1a1a1a]" data-id="element-111" data-mp="buombqxwruxg">
      <Bloom size="md" className="right-0 top-[-6rem]" data-id="element-112" data-mp="gmg69imk72em" />
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-12 px-6 py-20 lg:grid-cols-[1fr_1fr] lg:py-24" data-id="element-113" data-mp="gp2c9dtsx9uq">
        <div data-id="element-114" data-mp="3k3ok7re61i42">
          <SectionLabel data-id="element-115" data-mp="3k481r6zwm4hk">Ad reporting</SectionLabel>
          <h2 className="mt-8 text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-116" data-mp="3k5j6pa535ia9">
            Monthly reporting built in. No black box.
          </h2>
        </div>
        <div className="space-y-5 text-lg leading-relaxed text-neutral-400 lg:pt-16" data-id="element-117" data-mp="3u01eorhjbzzv">
          <p data-id="element-118" data-mp="2w2vl8ia99ll">
            You see what the ads spent and what they booked. Not impressions, not a slide deck.
          </p>
          <p data-id="element-119" data-mp="19dho5rhmzc1u">
            If something isn&rsquo;t working, you see it in the same report we do, and we tell you
            what we&rsquo;re changing.
          </p>
        </div>
      </div>

      <div className="mx-auto w-full max-w-6xl px-6 pb-20 lg:pb-24" data-id="element-120" data-mp="2ruha440ml432">
        <div className="flex flex-col items-start gap-5 rounded-2xl border border-[#1c1c1c] bg-[#0d0d0d] p-7 sm:flex-row sm:items-center" data-id="element-121" data-mp="2mx8ti7v4l83x">
          <div className="rounded-xl bg-white p-3" data-id="element-122" data-mp="2iwoueyqzruf5">
            <img src="https://cdn.magicpatterns.com/uploads/it67T9N3RYnBZ32NVuR62H/SEOcertified.png" alt="HubSpot SEO certified badge held by the Viridia Analytics team" className="h-16 w-auto object-contain" data-id="element-123" data-mp="2dufypumqie9c" />
          </div>
          <p className="max-w-xl text-sm leading-relaxed text-neutral-400" data-id="element-124" data-mp="1z63c3o9je7ri">
            HubSpot SEO certified. The people touching your ads, your site, and your Google
            profile have the training to back it up.
          </p>
        </div>
      </div>
    </section>;
}